export const PRE_RECORDED_DEMO_DEV =
  'tvF1NzQ01kzaTxo8iNvKfSvgtfJJ6xucppiYinuKpk1E';
export const PRE_RECORDED_DEMO_PROD =
  'puniLDQjY019DVwGi01ueIQtbfqUuryegrv2ZcAQn1e4o';

export const LILLIS_CS_DEV = '3F6HiOv4m9dsGavZRvIHIOT02rXpl01m2cGjnkRV01tmBo';
export const LILLIS_CS_PROD = 'dAN3Kcg5dyzipXyNPNiN9n6uJ00KYWp8pcE15GWiumBc';

export const CENTERBASE_CS_DEV = '72oWUa2tFPgEz99BvBJLghVKS5hTjN5Xsx3yvAasq9Q';
export const CENTERBASE_CS_PROD =
  'Yc8Dl3v1mg01RjDqyy02MYVRczwaCN01Ur201V6qpa128EM';

export const OOTBI_DEV = 'U3IzaZe8fQy5eSTaami00hUmNEUQalTao6AtaaheeNAo';
export const OOTBI_PROD = 'YUOBrTBb85MFxQ02nB9B601J2GbS8nP3AWLTCcmg9eIr00';

export const OOTBI_OLD_SIZES_DEV =
  'RvK8QCk9lWbxZxV6vlin701gCgp5Zt02i8bDUANcfbQas';
export const OOTBI_OLD_SIZES_PROD =
  'KOa027nZ2p29JLkrzbwN019J7fMkf4LjNP7E92Y3OTlt4';

export const OOTBI_CONSUMPTION_DEV =
  'dswgLs7uJk00AVisR5mjXTK5MzErHrkV4Bsjt4pycEYc';
export const OOTBI_CONSUMPTION_PROD =
  'dJcOLRnnI6aguYO02PH5L7vLH36bJ7501IaBogGZytYpw';
